window.addEventListener("DOMContentLoaded", function() {

    servicesInit();
    stickySectionInit();

    var calendlyBtns = document.querySelectorAll('.calendly-btn');
    for(var i = 0, length1 = calendlyBtns.length; i < length1; i++){
      calendlyBtns[i].addEventListener('click', calendlyInit, false);
    }
});

/**
 * Init Sticky Section
 */
function stickySectionInit() {
    var thresholdDefault = 1;
    var targets = document.querySelectorAll(".sticky-section__content");
    observer = new IntersectionObserver(checkStickyPosition, {
        threshold: thresholdDefault,
    });

    for (var i = 0, length1 = targets.length; i < length1; i++) {
        observer.observe(targets[i]);
    }

    var previousY = 0;
    var previousRatio = 0;

    var oldPosition = 1;
    function checkStickyPosition(entries) {
        var entry = entries[0];

        var currentY = entry.boundingClientRect.y
        var currentRatio = entry.intersectionRatio
        var isIntersecting = entry.isIntersecting

        if (currentRatio > 0 && isIntersecting) {
            var activePosition = entry.target.dataset.position;
            document
                .querySelector('[data-picture="'+ oldPosition +'"]')
                .classList.remove("sticky-section__picture--active");
            document
                .querySelector('[data-picture="' + activePosition + '"]')
                .classList.add("sticky-section__picture--active");
                oldPosition = activePosition;
        }
    }
}

/**
 * Init all function for services sections
 */
function servicesInit() {

    $('.services__slider').slick({
      infinite: true,
      slidesToShow: 3,
      variableWidth: true,
      centerMode: false,
      dots: true,
      arrows: true,
      appendArrows: $('.services__slider-controls'),
      appendDots: $('.services__slider-controls'),
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            variableWidth: true
          }
        },
        ]
    });

    $('.services__slider').on('beforeChange', function(event) {
      $('.services__slide').removeClass('services__slide--open services__slide--nohovered services__slide--hovered');
    });

    $('.services__slide').on('mouseenter', function(event) {
        $(this).addClass('services__slide--hovered');
        $('.services__slide:not(.services__slide--hovered)').addClass('services__slide--nohovered');
    });

    $('.services__slide').on('mouseleave', function(event) {
        $('.services__slide')
        .removeClass('services__slide--nohovered')
        .removeClass('services__slide--hovered');
    });

    $('.services__readmore').on('click', function(event) {
        $(this).parents('.services__slide').toggleClass('services__slide--open');
        $(this).find('span').toggleClass('hidden');
    })
}


/**
 * Display Calendly pop-in
 */
function calendlyInit(event) {
  event.preventDefault();
  Calendly.initPopupWidget({ url: event.target.href, branding: false });
  return false;
}